import { z } from 'zod';

// src/connect/types.ts
var ContactSourcePlatform = {
  Dashboard: "dashboard",
  Website: "website"
};
var StartChatInputSchema = z.object({
  name: z.string().trim().min(1, "Name is required").max(120, "Name is too long"),
  email: z.string().trim().min(1, "Email is required").max(254, "Email is too long").email("Enter a valid email address"),
  message: z.string().trim().max(4e3, "Message is too long").optional(),
  subject: z.string().trim().max(200, "Subject is too long").optional(),
  /** Free-form short slug (`dashboard` | `website` | …). Defaults server-side. */
  source_platform: z.string().trim().max(40).optional()
});
var StartChatHandshakeSchema = z.object({
  contact_id: z.string().min(1),
  participant_id: z.string().min(1),
  participant_token: z.string().min(1),
  region: z.string().min(1)
});
function parseStartChatInput(input) {
  return StartChatInputSchema.parse(input);
}
function parseStartChatHandshake(data) {
  return StartChatHandshakeSchema.parse(data);
}

// src/api/unwrap.ts
var ApiError = class extends Error {
  constructor(envelope) {
    super(envelope.error.message);
    this.envelope = envelope;
    this.name = "ApiError";
    this.statusCode = envelope.statusCode;
    this.code = envelope.error.error_code;
    this.level = envelope.error.error_level;
    this.details = envelope.error.details;
    this.correlationId = envelope.error.correlation_id;
  }
  envelope;
  statusCode;
  code;
  level;
  details;
  correlationId;
};
function unwrapResponse(res) {
  if (res.ok) return res;
  throw new ApiError(res);
}
function unwrapData(res) {
  return unwrapResponse(res).data;
}

// src/connect/client.ts
var CONNECT_CHAT_PATH = "/connect/chat";
async function startChat(api, input, opts = {}) {
  const payload = parseStartChatInput(input);
  const res = await api.post(CONNECT_CHAT_PATH, payload, opts.request);
  return parseStartChatHandshake(unwrapData(res));
}
var ConnectChatClient = class {
  constructor(api) {
    this.api = api;
  }
  api;
  startChat(input, opts) {
    return startChat(this.api, input, opts);
  }
};

// src/connect/session.ts
async function loadChatJs() {
  const moduleSpecifier = "amazon-connect-chatjs";
  let mod;
  try {
    mod = await import(
      /* @vite-ignore */
      moduleSpecifier
    );
  } catch (error) {
    throw new Error(
      "amazon-connect-chatjs is not installed. Add it to the host app to use createChatSession(): " + (error instanceof Error ? error.message : String(error))
    );
  }
  const candidate = mod;
  const fromModule = candidate.ChatSession ? candidate : candidate.default;
  if (fromModule && fromModule.ChatSession) return fromModule;
  const glob = globalThis;
  if (glob.connect?.ChatSession) return glob.connect;
  throw new Error("amazon-connect-chatjs loaded but no ChatSession factory was found.");
}
async function createChatSession(handshake, opts = {}) {
  const connect = await loadChatJs();
  const region = opts.region ?? handshake.region;
  connect.ChatSession.setGlobalConfig({
    region,
    loggerConfig: { level: opts.logLevel ?? "ERROR" }
  });
  return connect.ChatSession.create({
    chatDetails: {
      contactId: handshake.contact_id,
      participantId: handshake.participant_id,
      participantToken: handshake.participant_token
    },
    type: connect.ChatSession.SessionTypes.CUSTOMER,
    options: { region }
  });
}

export { CONNECT_CHAT_PATH, ConnectChatClient, ContactSourcePlatform, StartChatHandshakeSchema, StartChatInputSchema, createChatSession, parseStartChatHandshake, parseStartChatInput, startChat };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map